import { DialogContent } from '@mui/material';
import FormDatePicker from 'components/_commons/Form/Inputs/Datepicker/FormDatePicker';
import { CustomActionButtons } from 'components/_commons/Modals/_CustomActionButtons';
import { ModalFormField } from 'components/_commons/Modals/_ModalFormField';
import { ModalHeader } from 'components/_commons/Modals/_ModalHeader';
import React, { useCallback, useState } from 'react';
import { FormContainer, useForm } from 'react-hook-form-mui';
import { translate } from 'utils';
import { DateHelper } from 'utils/helpers';
import { ModalProps } from '../../../hooks/ModalProvider';

export const EditFluidBalanceCampaignModal = ({
  onClose,
  onSubmit,
  reopen,
  defaultValues
}: ModalProps<any>) => {
  const formContext = useForm({ defaultValues });
  const { watch } = formContext;
  const [isUpdatingBalanceCampaign, setIsUpdatingBalanceCampaign] = useState(false);

  const onSubmitModal = useCallback(() => onSubmit(DateHelper.getLocalDateTime(watch('endDate')), setIsUpdatingBalanceCampaign), [onSubmit, watch]);

  return (
    <FormContainer
      formContext={formContext}
      FormProps={{ autoComplete: 'off', name: 'disableAttestationModal' }}
      onSuccess={onSubmitModal}
    >
      <ModalHeader onClose={onClose}>
        {reopen ? translate('fluidBalanceCampaignModal.reopen.title') : translate('fluidBalanceCampaignModal.edit.title')}
      </ModalHeader>

      <DialogContent style={{ marginTop: 30 }}>
        <ModalFormField title={translate('fluidBalanceCampaignModal.endDate.title')}>
          <FormDatePicker
            disablePast
            label="fluidBalanceCampaignModal.endDate.label"
            name="endDate"
            required
          />
        </ModalFormField>
      </DialogContent>

      <CustomActionButtons isSaving={isUpdatingBalanceCampaign} submitLabelKey="confirms.confirm" onClose={onClose} />
    </FormContainer>
  );
};
